import { render, staticRenderFns } from "./SchemaModal.vue?vue&type=template&id=688db866&"
import script from "./SchemaModal.vue?vue&type=script&lang=js&"
export * from "./SchemaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports